module.exports = __webpack_public_path__ + "img/add.c94f8881.svg";